import type { Locale } from '@skytech/types'
import { DEFAULT_LOCALE, getFormattedNumber } from '@skytech/utils'

import { useProfile } from '@/hooks/user'

export const useFormattedNumber = () => {
  const profile = useProfile()

  const formatNumber = ({
    amount,
    locale,
    precision,
  }: {
    amount: number
    locale?: Locale
    precision?: number
  }) =>
    getFormattedNumber({
      amount,
      precision,
      locale: locale || profile?.locale || DEFAULT_LOCALE,
    })

  return { formatNumber }
}
